const clearSelection = () => {
  // Do not clear the range if the user is activly editing an input!
  if (!/^input$/i.test(document.activeElement.tagName)) {
    // clears any selection that happened during dragging
    window.getSelection().removeAllRanges();
  }
};

export default clearSelection;
